/*    
<summary>
   This Store works for Booking Management (CRUD Add, Update, Delete, Read).
   Developer:Mohammad Saquib Khan, Created Date:07-Mar-2025
</summary>
<param>No Parameter Passed</param>
<returns>Returns class instance</returns>
*/
import base64 from "base-64";
import { jwtDecode } from "jwt-decode";
import { cloneDeep } from "lodash";
import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from "mobx";
import moment from "moment";
import toast from "react-hot-toast";
import { combineDateTime, DATE_FORMAT, safeBase64Encode } from "../../constants/constants";
import userTypeEnum from "../../constants/enums/user-type-enum";
import { DateTimeFormatTZ } from "../../constants/time-picker-constant";
import URLConstants from "../../constants/url-constants";
import config from "../../helpers/config-helper";
import ILogin, { ICustomerLogin } from "../../models/forms/ILogin";
import { IObservableInitialState } from "../../models/ICommon";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { ICustomerAuthResponse } from "../../models/response/IAuthResponse";
import {
  IReservationListVM,
  IReservationProcessStateVM,
  IReservationVM,
} from "../../models/response/IReservationResponse";
import { ShiftSchedule } from "../../models/response/IShiftManagementResponse";
import { ITreatmentOptionMenuList } from "../../models/response/ITreatmentManagementResponse";
import { ICommonState } from "../../models/state/ICommonState";
import { formatMessage } from "../../translations/format-message";
import { initialState as GetAllReservationState } from "../initialState/get-all-reservation-state";
import { initialState as GetAllCancelledReservationState } from "../initialState/get-all-cancelled-reservation-state";
import { initialState } from "../initialState/add-edit-cutomer-management-state";
import * as baseService from "../service/base-service";
import {
  getBlockedStoreIdsCustomerFromLocalStorage,
  getBusinessTypeIdFromLocalStorage,
  getStoreIdFromLocalStorage,
  getTokenFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../helpers/localstorage-helper";
import { ICancellationListVM } from "../../models/response/ICancelledReservationResponse";
import { ICustomerVM } from "../../models/response/ICustomerManagementResponse";
import { AppointmentProcessState } from "../../constants/enums/appointment-process-state-enum";
import { CategoryManagementStore } from "./category-management-store";
import bookingStatusEnum from "../../constants/enums/booking-status-enum";
import { AuthStore } from "./auth-store";

const appConfig = config();
const dateFormat = appConfig.REACT_APP_DATE_FORMAT;
export class BookingManagementStore implements ICommonState {
  inProgress = false;
  error = "";

  initialStateValue: IObservableInitialState = {
    success: false,
    error: "",
    inProgress: false,
  };

  shiftScheduleList: ShiftSchedule[] = [];
  reservationList: IReservationListVM = GetAllReservationState;
  customer: ICustomerVM | undefined = undefined;

  appointmentType: any = 1;

  reservationProcessStateResponse: any = undefined;
  isPollingActive: boolean = false;

  appointment: any | undefined = undefined;
  mapSlot: any | undefined = undefined;
  mapSlotState = { ...this.initialStateValue };
  bookingStatus = 0;

  userType = "";
  isAuthenticated = false;

  selectedService: any | undefined = undefined;
  isSourceFeatured: boolean = false;

  accordionData = observable.map<number, any[]>(new Map());
  accordionLoading = new Map<number, boolean>();

  appointmentByIdState = { ...this.initialStateValue };
  blockedAppointment: any[] = [];
  blockedAppointmentState = { ...this.initialStateValue };

  staffShiftScheduleState = { ...this.initialStateValue };
  authenticateCustomerState = { ...this.initialStateValue };
  addUpdateAppointmentState = { ...this.initialStateValue };
  getReservationListState = { ...this.initialStateValue };
  getTreatmentOptionMenuListState = { ...this.initialStateValue };
  customerState = { ...this.initialStateValue };
  treatmentOptionMenuList: ITreatmentOptionMenuList[] = [];

  getCancelledReservationListState = { ...this.initialStateValue };
  addUpdateCustomerState = { ...this.initialStateValue };
  cancelledReservationList: ICancellationListVM =
    GetAllCancelledReservationState;

  constructor() {
    makeObservable(this, {
      inProgress: observable,
      error: observable,
      appointmentType: observable,
      isPollingActive: observable,
      mapSlot: observable,
      mapSlotState: observable,
      reservationProcessStateResponse: observable,
      customer: observable,
      shiftScheduleList: observable,
      isSourceFeatured: observable,
      addUpdateCustomerState: observable,
      authenticateCustomerState: observable,
      getTreatmentOptionMenuListState: observable,
      accordionLoading: observable,
      addUpdateAppointmentState: observable,
      reservationList: observable,
      getReservationListState: observable,
      appointment: observable,
      appointmentByIdState: observable,
      accordionData: observable,
      userType: observable,
      isAuthenticated: observable,
      staffShiftScheduleState: observable,
      treatmentOptionMenuList: observable,
      blockedAppointment: observable,
      blockedAppointmentState: observable,
      customerState: observable,
      cancelledReservationList: observable,
      getCancelledReservationListState: observable,
      bookingStatus: observable,
      selectedService: observable,
      fetchTreatmentOptionsForAllCategories: action,
      GetTreatmentOptionMenuListByCatIdService: action,
      setSelectedService: action,
      GetTreatmentOptionMenuListByCatIdCustomerService: action,
      GetReservationProcessStateService: action,
      pollReservationProcessState: action,
      stopPolling: action,
      GetReservationListFilterService: action,
      AddWalkInCustomerAppointmentService: action,
      AuthenticateCustomer: action,
      resetAppointmentState: action,
      AddAppointmentService: action,
      updateWalkInBookingData: action,
      updateBookingData: action,
      updateTreatmentOrder: action,
      GetAppointmentByIdService: action,
      setIsSourceFeatured: action,
      GetShiftScheduleListByStoreIdService: action,
      GetNoOfAvailabilityServiceDatesBlock: action,
      UpdateAppointmentStatusService: action,
      AddCustomerRegister: action,
      resetCustomerDetail: action,
      setBookingStatus: action,
      getData: action,
      resetAppointmentStateError: action,
      GetTheDateTimeSlotsMappingService: action,
      resetAppointmentDetail: action,
      resetBookingStore: action,
      getAccordionDataById: action,
      resetBlockedAppointment: action,
      resetShiftScheduleList: action,
      resetAddUpdateCustomer: action,
      setAppointmentType: action,
      allTreatmentOptionMenu: computed,
      customerDetail: computed,
      allReservationList: computed,
      allCurrentReservationList: computed,
      allPastReservationList: computed,
      allReservationsEvents: computed,
      getShiftScheduleList: computed,
      getTreatmentData: computed,
      apponitmentDetail: computed,
      availableDatesBlock: computed,
      mapCalendarSlots: computed,
      allCancelledReservations: computed,
      getBookingStatus: computed,
      getSelectedService: computed,
      getIsSourceFeatured: computed
    });
  }

  /**
   * This function is used to Add Appointment by calling an API.
   * @param data : Appointment Data
   * @returns
   */
  AddAppointmentService = (data: any) => {
    this.addUpdateAppointmentState.inProgress = true;
    this.addUpdateAppointmentState.error = "";
    this.addUpdateAppointmentState.success = false;
    this.isPollingActive = true; // flag to control polling lifecycle

    const url = URLConstants.AddAppointment;

    return baseService
      .postRequest(url, data)
      .then(
        action((response: IApiResponse<IApiSuccessResponse<any>>) => {
          if (response.data.Error) {
            this.addUpdateAppointmentState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
            this.addUpdateAppointmentState.inProgress = false;
          } else {
            const stateId = response.data.Data;
            if (stateId == null) {
              // Defensive: no stateId returned
              this.addUpdateAppointmentState.error = "NoStateIdReturned";
              this.addUpdateAppointmentState.inProgress = false;
              // console.log(
              //   "No StateId returned from AddWalkInCustomerAppointment API"
              // );
              return;
            }
            // Start polling with the stateId
            this.pollReservationProcessState(stateId);
          }
        })
      )
      .catch(
        action((err: any) => {
          this.addUpdateAppointmentState.error =
            err?.message ||
            err?.toString() ||
            "Error adding walk-in appointment";
          toast.error(this.addUpdateAppointmentState.error);
          this.addUpdateAppointmentState.inProgress = false;
        })
      );
  };

  AddWalkInCustomerAppointmentService = (data: any) => {
    this.addUpdateAppointmentState.inProgress = true;
    this.addUpdateAppointmentState.error = "";
    this.addUpdateAppointmentState.success = false;
    this.isPollingActive = true; // flag to control polling lifecycle

    const url = URLConstants.AddWalkInCustomerAppointment;

    return baseService
      .postRequest(url, data)
      .then(
        action((response: IApiResponse<IApiSuccessResponse<any>>) => {
          if (response.data.Error) {
            this.addUpdateAppointmentState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
            this.addUpdateAppointmentState.inProgress = false;
          } else {
            const stateId = response.data.Data;
            if (stateId == null) {
              // Defensive: no stateId returned
              this.addUpdateAppointmentState.error = "NoStateIdReturned";
              this.addUpdateAppointmentState.inProgress = false;
              console.log(
                "No StateId returned from AddWalkInCustomerAppointment API"
              );
              return;
            }
            // Start polling with the stateId
            this.pollReservationProcessState(stateId);
          }
        })
      )
      .catch(
        action((err: any) => {
          this.addUpdateAppointmentState.error =
            err?.message ||
            err?.toString() ||
            "Error adding walk-in appointment";
          toast.error(this.addUpdateAppointmentState.error);
          this.addUpdateAppointmentState.inProgress = false;
        })
      );
  };

  // Polling function
  pollReservationProcessState = (stateId: number) => {
    if (!this.isPollingActive) {
      // Polling stopped externally (e.g., on unmount)
      this.getReservationListState.inProgress = false;
      return;
    }

    this.getReservationListState.inProgress = true;

    this.GetReservationProcessStateService(stateId)
      .then(
        action(
          (
            response: IApiResponse<
              IApiSuccessResponse<IReservationProcessStateVM>
            >
          ) => {
            if (response.data.Error) {
              this.getReservationListState.error = response.data.Message;
              toast.error(formatMessage(response.data.Message));
              this.getReservationListState.inProgress = false;
              this.isPollingActive = false; // stop polling on error
            } else {
              const data = response.data.Data;
              this.reservationProcessStateResponse = data;
              this.getReservationListState.error = "";

              if (data.Status === AppointmentProcessState.Complete) {
                this.addUpdateAppointmentState.inProgress = false;
                this.getReservationListState.inProgress = false;
                this.addUpdateAppointmentState.success = true;
                // console.log("Process state is Success!");
                this.isPollingActive = false; // done polling
              } else if (data.Status === AppointmentProcessState.Error) {
                this.addUpdateAppointmentState.inProgress = false;
                this.getCancelledReservationListState.inProgress = false;
                this.addUpdateAppointmentState.error = data.Response;
                this.isPollingActive = false;
                toast.error(this.addUpdateAppointmentState.error);
              } else {
                // polling not complete, continue after 1 second
                setTimeout(() => {
                  this.pollReservationProcessState(stateId);
                }, 1000);
              }
            }
          }
        )
      )
      .catch(
        action((err: any) => {
          this.getReservationListState.error =
            err?.message ||
            err?.toString() ||
            "Error polling reservation process state";
          // console.log(this.getReservationListState.error);
          this.getReservationListState.inProgress = false;
          this.isPollingActive = false; // stop polling on error
        })
      );
  };

  // Modified GetReservationProcessStateService - NO inProgress mutation here
  GetReservationProcessStateService = (stateId: number) => {
    const url =
      URLConstants.GetReservationProcessStateById +
      "RequestStatus?Id=" +
      stateId;
    return baseService
      .getRequest(url)
      .then(
        (
          response: IApiResponse<
            IApiSuccessResponse<IReservationProcessStateVM>
          >
        ) => {
          if (response.data.Error) {
            this.getReservationListState.error = response.data.Message;
          } else {
            this.reservationProcessStateResponse = response.data.Data;
            this.getReservationListState.error = "";
          }
          return response;
        }
      )
      .catch((err: any) => {
        this.getReservationListState.error =
          err?.message || err?.toString() || "API Error";
        throw err; // propagate error to poller
      });
  };

  // Optional: method to stop polling if needed (e.g., on component unmount)
  stopPolling = () => {
    this.isPollingActive = false;
    this.getReservationListState.inProgress = false;
  };

  setAppointmentType = (type: any) => {
    this.appointmentType = type;
  };

  UpdateAppointmentStatusService = (data: any) => {
    this.addUpdateAppointmentState.inProgress = true;
    let url = URLConstants.UpdateAppointmentStatus;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateAppointmentState.error = response.data.Message;
        } else this.addUpdateAppointmentState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateAppointmentState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateAppointmentState.inProgress = false;
        })
      );
  };

  AddCustomerRegister = (data: any, bookingData: any, RegisterCustomerlogin: (data:{Email: string; Password: string}) => void) => {
    this.addUpdateCustomerState.inProgress = true;
    let url = URLConstants.AddCustomerRegister;
    const requestData = {
      FirstName: data.FirstName || null,
      LastName: data.LastName || null,
      FirstNameKana: data.FirstNameKana || null,
      LastNameKana: data.LastNameKana || null,
      Dob: data.Dob || null,
      Gender: data.Gender ?? null,
      Phone1: data.Phone1 && data.Phone1.trim() !== "" ? data.Phone1 : null,
      // Phone2: data.Phone2 && data.Phone2.trim() !== "" ? data.Phone2 : null,
      Email: data.Email.toLowerCase() || null,
      PostalCode: data.PostalCode ? String(data.PostalCode) : null,
      Address: data.Address || "",
      PrefectureName: data.PrefectureName || null,
      DianaCode: data.DianaCode || null,
      AppMemberShipCode: data.AppMemberShipCode || null,
      Referer: data.Referer || null,
      IsBlocked: data.IsBlocked ?? false,
      Memo: data.Memo || null,
      DmDshs:
        data.DmDshs === true || data.DmDshs === false ? data.DmDshs : false,
      Password: safeBase64Encode(data.Password) || null,
      CustomerType: data.CustomerType ?? null,
      RegisteredBy: data.RegisteredBy ?? null,
      StoreId: data.StoreId ?? null,
      UserId: data.UserId ?? null,
      Status: data.Status,
      IsOverwriteEmail: data?.IsOverwriteEmail,
      CustomerMotiveDetails:
        data.CustomerMotiveDetails?.map((detail: any) => ({
          MId: detail.MId ?? null,
          CustId: detail.CustId ?? null,
        })) || [],
    };

    return baseService
      .postRequest(url, requestData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateCustomerState.error = response.data.Message;
        } else {
          let dataId = response.data.Data;
          if (dataId > 0) {
            if (this.appointmentType == 3) {
              RegisterCustomerlogin({
                Email: data.Email,
                Password: safeBase64Encode(data.Password)
              });
            } 
            this.AddAppointmentService(
              this.updateBookingData(bookingData, dataId)
            );
          }
          this.addUpdateCustomerState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateCustomerState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateCustomerState.inProgress = false;
        })
      );
  };

  get customerDetail(): any {
    if (this.customer) {
      return {
        Id: this.customer.Id ?? 0,
        FirstName: this.customer.FirstName ?? "",
        LastName: this.customer.LastName ?? "",
        FirstNameKana: this.customer.FirstNameKana ?? "",
        LastNameKana: this.customer.LastNameKana ?? "",
        Dob: this.customer.Dob
          ? moment(this.customer.Dob).format(dateFormat)
          : "",
        Gender: this.customer.Gender?.toString() || "0",
        Phone1: this.customer.Phone1 ?? "",
        // Phone2: this.customer.Phone2 ?? "",
        Email: this.customer.Email ?? "",
        PostalCode: this.customer.PostalCode
          ? String(this.customer.PostalCode)
          : "",
        Address: this.customer.Address ?? "",
        PrefectureName: this.customer.PrefectureName ?? "",
        DianaCode: this.customer.DianaCode ?? "",
        AppMemberShipCode: this.customer.AppMemberShipCode ?? "",
        Referer: this.customer.Referer ?? "",
        Memo: this.customer.Memo ?? "",
        DmDshs: this.customer.DmDshs.toString(),
        Status: this.customer.Status?.toString() || "0",
        IsBlocked: this.customer.IsBlocked ?? false,
        DobYear: this.customer.Dob
          ? Number(moment(this.customer.Dob).format(dateFormat).split("-")[0])
          : -1,
        DobMonth: this.customer.Dob
          ? Number(moment(this.customer.Dob).format(dateFormat).split("-")[1])
          : -1,
        DobDate: this.customer.Dob
          ? Number(moment(this.customer.Dob).format(dateFormat).split("-")[2])
          : -1,

        CustomerMotiveDetails: Array.isArray(this.customer.CustomerMotiveList)
          ? this.customer.CustomerMotiveList.map((motive) => ({
              MId: motive.MId,
              CustId: motive.CustId,
            }))
          : [],

        MotivationOptions: Array.isArray(this.customer.CustomerMotiveList)
          ? this.customer.CustomerMotiveList.map((motive) => String(motive.MId))
          : [],
        TotalCount: this.customer.TotalCount,
      };
    }
    return initialState;
  }

  /*
        This function is used to reset all customer observables to their initial values.  
        */
  resetCustomerDetail = () => {
    this.customer = undefined;
    this.customerState = { ...this.initialStateValue };
  };

  resetAddUpdateCustomer = () => {
    this.addUpdateCustomerState = { ...this.initialStateValue };
    this.addUpdateAppointmentState = { ...this.initialStateValue };
  };

  GetReservationListFilterService = (
    pageNo: any,
    pageSize: any,
    startDate: any,
    endDate: any,
    appointmentStatus: any,
    customerid: any
  ) => {
    this.getReservationListState.inProgress = true;
    let url =
      URLConstants.GetReservationListFilter +
      "?PageNo=" +
      pageNo +
      "&PageSize=" +
      pageSize +
      "&startDate=" +
      moment(startDate).format("YYYY-MM-DD") +
      "&endDate=" +
      moment(endDate).format("YYYY-MM-DD") +
      "&appointmentStatus=" +
      appointmentStatus +
      "&customerid=" +
      customerid;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IReservationListVM>>) => {
          if (response.data.Error) {
            this.getReservationListState.error = response.data.Message;
          } else {
            let data = response.data.Data;
            this.reservationList = data;
          }
        }
      )
      .catch((err: string) => {
        this.getReservationListState.error = err;
      })
      .finally(
        action(() => {
          this.getReservationListState.inProgress = false;
        })
      );
  };

  get allReservationList(): any[] {
    if (this.reservationList.AppointmentListVMs?.length > 0) {
      return this.reservationList.AppointmentListVMs?.map(
        (reservation: any) => {
          return {
            Id: reservation.Id,
            CustomerId: reservation.CustomerId,
            StoreId: reservation.StoreId,
            StaffPreference: reservation.StaffPreference,
            RequestedStaffId: reservation.RequestedStaffId,
            AssignedStaffId: reservation.AssignedStaffId,
            NominationFee:
              reservation.NominationFee !== null
                ? reservation.NominationFee
                : 0,
            Date: reservation.Date,
            Time: reservation.Time,
            Store: reservation.store,
            StaffName: reservation.StaffName,
            AppointmentStatus: reservation.AppointmentStatus,
            PaymentType: reservation.PaymentType,
            ServiceRequestedVMss: reservation.ServiceRequestedVMss,
            TotalTime: reservation.TotalTime,
            TotalAmount: reservation.TotalAmount,
            TotalTaxes: reservation.TotalTaxes,
            ConsumptionTax: reservation.ConsumptionTax,
          };
        }
      );
    }
    return [];
  }
  get allCurrentReservationList(): any[] {
    if (this.reservationList.AppointmentListVMs?.length > 0) {
      return this.reservationList.AppointmentListVMs?.filter((reservation:any)=> (
        reservation?.AppointmentStatus ===
        bookingStatusEnum.InProcess ||
        reservation?.AppointmentStatus ===
        bookingStatusEnum.Reserved)).map(
        (reservation: any) => {
          return {
            Id: reservation.Id,
            CustomerId: reservation.CustomerId,
            StoreId: reservation.StoreId,
            StaffPreference: reservation.StaffPreference,
            RequestedStaffId: reservation.RequestedStaffId,
            AssignedStaffId: reservation.AssignedStaffId,
            NominationFee:
              reservation.NominationFee !== null
                ? reservation.NominationFee
                : 0,
            Date: reservation.Date,
            Time: reservation.Time,
            Store: reservation.store,
            StaffName: reservation.StaffName,
            AppointmentStatus: reservation.AppointmentStatus,
            PaymentType: reservation.PaymentType,
            ServiceRequestedVMss: reservation.ServiceRequestedVMss,
            TotalTime: reservation.TotalTime,
            TotalAmount: reservation.TotalAmount,
            TotalTaxes: reservation.TotalTaxes,
            ConsumptionTax: reservation.ConsumptionTax,
          };
        }
      );
    }
    return [];
  }
  get allPastReservationList(): any[] {
    if (this.reservationList.AppointmentListVMs?.length > 0) {
      return this.reservationList.AppointmentListVMs?.filter((reservation:any)=> (
        reservation?.AppointmentStatus ===
        bookingStatusEnum.Complete ||
        reservation?.AppointmentStatus ===
        bookingStatusEnum.Cancelled)).map(
        (reservation: any) => {
          return {
            Id: reservation.Id,
            CustomerId: reservation.CustomerId,
            StoreId: reservation.StoreId,
            StaffPreference: reservation.StaffPreference,
            RequestedStaffId: reservation.RequestedStaffId,
            AssignedStaffId: reservation.AssignedStaffId,
            NominationFee:
              reservation.NominationFee !== null
                ? reservation.NominationFee
                : 0,
            Date: reservation.Date,
            Time: reservation.Time,
            Store: reservation.store,
            StaffName: reservation.StaffName,
            AppointmentStatus: reservation.AppointmentStatus,
            PaymentType: reservation.PaymentType,
            ServiceRequestedVMss: reservation.ServiceRequestedVMss,
            TotalTime: reservation.TotalTime,
            TotalAmount: reservation.TotalAmount,
            TotalTaxes: reservation.TotalTaxes,
            ConsumptionTax: reservation.ConsumptionTax,
          };
        }
      );
    }
    return [];
  }

  get allReservationsEvents(): any[] {
    if (this.reservationList.AppointmentListVMs?.length > 0) {
      return this.reservationList.AppointmentListVMs?.map(
        (reservation: any) => {
          return {
            id: reservation.Id,
            CustomerId: reservation.CustomerId,
            StoreId: reservation.StoreId,
            StaffPreference: reservation.StaffPreference,
            RequestedStaffId: reservation.RequestedStaffId,
            AssignedStaffId: reservation.AssignedStaffId,
            Date: reservation.Date,
            Time: reservation.Time,
            title: reservation.StaffName,
            start: combineDateTime(reservation.Date, reservation.Time),
            end: moment(
              combineDateTime(reservation.Date, reservation.Time).add(
                120,
                "minutes"
              )
            ),
            Store: reservation.store,
            StaffName: reservation.StaffName,
            AppointmentStatus: reservation.AppointmentStatus,
            PaymentType: reservation.PaymentType,
            ServiceRequestedVMss: reservation.ServiceRequestedVMss,
          };
        }
      );
    }
    return [];
  }

  GetTreatmentOptionMenuListByCatIdService = (
    id: number,
    staffId?: any,
    storeId?: number
  ) => {
    this.getTreatmentOptionMenuListState.inProgress = true;

    const BusinessTypeId = getBusinessTypeIdFromLocalStorage() ?? -1;
    const StoreId = storeId ? storeId : getStoreIdFromLocalStorage() ?? -1;
    const IsStore = storeId && storeId > 0 ? false : true;
    const StaffId = staffId ? staffId : null;
    const urlParams = new URLSearchParams();
    urlParams.append("category_id", String(id));
    urlParams.append("store_id", String(StoreId));
    urlParams.append("businessTypeId", String(BusinessTypeId));
    urlParams.append("IsStore", String(IsStore));
    if (StaffId) {
      urlParams.append("staffId", String(StaffId));
    }
    const url =
      `${URLConstants.GetTreatmentOptionMenuByCatId}?` + urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getTreatmentOptionMenuListState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.treatmentOptionMenuList = data;
          if (Array.isArray(data) && data?.length > 0) {
            if (this.accordionData.has(id)) {
              // Replace existing data
              this.accordionData.set(id, data);
            } else {
              // Append new entry
              this.accordionData.set(id, [
                ...(this.accordionData.get(id) || []),
                ...data,
              ]);
            }
          }
        }
      })
      .catch((err: string) => {
        this.getTreatmentOptionMenuListState.error = err;
      })
      .finally(
        action(() => {
          this.getTreatmentOptionMenuListState.inProgress = false;
        })
      );
  };

  GetTreatmentOptionMenuListByCatIdCustomerService = (
    id: number,
    staffId?: any,
    storeId?: number,
    businessTypeId: number | null = null,
    accumulate: boolean = false, // Pass true if you want merge/accumulate
  ) => {
    runInAction(() => {
      this.accordionLoading.set(id, true);
    });

    const BusinessTypeId = businessTypeId ? businessTypeId : (getBusinessTypeIdFromLocalStorage() ?? -1);
    const StoreId = storeId ? storeId : getStoreIdFromLocalStorage() ?? -1;
    const IsStore = storeId && storeId > 0 ? false : true;
    const StaffId = staffId ? staffId : null;
    const urlParams = new URLSearchParams();
    urlParams.append("category_id", String(id));
    urlParams.append("store_id", String(StoreId));
    urlParams.append("businessTypeId", String(BusinessTypeId));
    urlParams.append("IsStore", String(IsStore));
    if (StaffId) {
      urlParams.append("staffId", String(StaffId));
    }
    const url =
      `${URLConstants.GetTreatmentOptionMenuByCatId}?` + urlParams.toString();

    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getTreatmentOptionMenuListState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.treatmentOptionMenuList = data;
          if (Array.isArray(data) && data?.length > 0) {
            if (this.accordionData.has(id)) {
              // Replace existing data
              this.accordionData.set(id, data);
            } else {
              // Append new entry
              this.accordionData.set(id, [
                ...(this.accordionData.get(id) || []),
                ...data,
              ]);
            }
          }
        }
      })
      .catch((err: string) => {
        this.getTreatmentOptionMenuListState.error = err;
      })
      .finally(
        action(() => {
          this.accordionLoading.set(id, false);
        })
      );
  };

  // Modified fetch method with per-category progress
  fetchTreatmentOptionsForAllCategories = async (
    categories: any[],
    storeId: any,
    businessTypeId: number = -1
  ) => {
    if (!categories.length) return;

    runInAction(() => {
      this.getTreatmentOptionMenuListState.inProgress = true;
    });

    try {
      const requests = categories.map((category) =>
        this.GetTreatmentOptionMenuListByCatIdCustomerService(
          category.id,
          null,
          storeId,
          businessTypeId
        )
      );
      await Promise.all(requests);
    } catch (error) {
      runInAction(() => {});
    } finally {
      runInAction(() => {
        this.getTreatmentOptionMenuListState.inProgress = false;
      });
    }
  };

  get allTreatmentOptionMenu(): any[] {
    if (this.treatmentOptionMenuList?.length > 0) {
      return this.treatmentOptionMenuList?.map((treatments) => {
        return {
          Id: treatments.Id,
          TreatmentName: treatments.TreatmentName,
          CategoryId: treatments.CategoryId,
          optionVm: treatments.optionVm,
        };
      });
    }
    return [];
  }

  getData = (accordionId: number) => {
    return this.accordionData.get(accordionId) || [];
  };

  get getTreatmentData() {
    return this.accordionData;
  }

  // In your store:
  updateTreatmentOrder = async (categoryId: string, treatments: any[]) => {
    // Update local state
    // const updatedMap = new Map(this.getTreatmentData);
    this.accordionData.set(Number(categoryId), treatments);
    // this.setTreatmentData(updatedMap);
  };

  getAccordionDataById = (id: number) => {
    let result: any = null;
    this.accordionData.forEach((items, categoryId) => {
      if (!result) {
        const foundItem = items.find((item: { Id: number }) => item.Id === id);
        if (foundItem) {
          result = foundItem;
        }
      }
    });
    return result;
  };

  AuthenticateCustomer = (data: ICustomerLogin, bookingData: any) => {
    this.authenticateCustomerState.inProgress = true;
    this.error = "";
    const authData = {
      Email: data.email,
      Password: safeBase64Encode(data.password),
    };
    return baseService
      .postRequest(URLConstants.CustomerAuthenticate, authData)
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<ICustomerAuthResponse>>
        ) => {
          if (response.data.Error) {
            this.authenticateCustomerState.error = response.data.Message;
          } else {
            let data = response.data.Data;
            const userToken: any = jwtDecode(data.AccessToken);
            this.userType = userTypeEnum[userToken.userType];
            if (data.BusinessTypeId !== null) {
              localStorage.setItem(
                "lizera_businessTypeId",
                data.BusinessTypeId?.toString()
              );
            }
            localStorage.setItem(
              "lizera_userType",
              userTypeEnum[userToken.userType]
            );
            localStorage.setItem("lizera_email", userToken.customerEmail);
            localStorage.setItem("lizera_userId", userToken.customerId);
            localStorage.setItem("lizera_token", data.AccessToken);
            localStorage.setItem("lizera_is_access_tenant", "false");
            localStorage.setItem("lizera_access_tenant_name", "");
            localStorage.setItem(
              "lizera_blocked_stores",
              JSON.stringify(data.StoreIds)
            );
            this.isAuthenticated = true;
            if (data.CustomerId > 0) {
              if (
                getTokenFromLocalStorage() !== "" &&
                getUserTypeFromLocalStorage() == "Customer"
              ) {
                if (getBlockedStoreIdsCustomerFromLocalStorage()?.length > 0) {
                  let isBlockedSelectedStore =
                    getBlockedStoreIdsCustomerFromLocalStorage()?.some(
                      (item: number) => item == bookingData.StoreId
                    );
                  if (isBlockedSelectedStore) {
                    this.addUpdateAppointmentState.error =
                      "UserIsBlockedForTheSelectedStore";
                  } else {
                    this.AddAppointmentService(
                      this.updateBookingData(bookingData, data.CustomerId)
                    );
                  }
                }
                else{
                    this.AddAppointmentService(
                      this.updateBookingData(bookingData, data.CustomerId)
                    );
                  }
              }
            }
            this.authenticateCustomerState.success = true;
            // toast.success(formatMessage("AuthenticatedSuccessfully"));
          }
        }
      )
      .catch((err: string) => {
        this.authenticateCustomerState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.authenticateCustomerState.inProgress = false;
        })
      );
  };

  updateBookingData = (bookingData: any, customerId: number) => {
    let serviceArr: any[] = [];
    let tempValues = cloneDeep(bookingData);
    tempValues.CustomerId = customerId;
    bookingData.Service?.map((data: any) => {
      serviceArr.push({
        CustomerId: customerId,
        ServiceId: data.ServiceId,
        ServiceType: data.ServiceType,
        ServiceName: data.ServiceName,
        ParentId: data.ParentId,
        Charges: data.Charges,
        Tax: data.Tax,
        TimeValue: data.TimeValue,
        TaxAmount: data.TaxAmount,
      });
    });
    tempValues.Service = serviceArr;
    return tempValues;
  };

  updateWalkInBookingData = (bookingData: any) => {
    let serviceArr: any[] = [];
    let tempValues = cloneDeep(bookingData);
    delete tempValues.CustomerId;
    bookingData.Service?.map((data: any) => {
      serviceArr.push({
        ServiceId: data.ServiceId,
        ServiceType: data.ServiceType,
        ServiceName: data.ServiceName,
        ParentId: data.ParentId,
        Charges: data.Charges,
        Tax: data.Tax,
        TimeValue: data.TimeValue,
        TaxAmount: data.TaxAmount,
      });
    });
    tempValues.Service = serviceArr;

    return tempValues;
  };

  resetAppointmentState = () => {
    this.addUpdateAppointmentState = { ...this.initialStateValue };
  };

    resetAppointmentStateError = () => {
    this.addUpdateAppointmentState.error = "";
  };

  resetBookingStore = () => {
    this.accordionData.clear(); // clears existing map entries without replacing reference
    this.getTreatmentOptionMenuListState = { ...this.initialStateValue };
    this.treatmentOptionMenuList = [];
    // new CategoryManagementStore().resetCategoryList();
  };

  GetShiftScheduleListByStoreIdService = (
    storeId: number,
    StartDate: string,
    EndDate: string,
    userId: any,
    gender: any
  ) => {
    this.staffShiftScheduleState.inProgress = true;
    const dateFilter = {
      StartDate: moment(StartDate).format(DATE_FORMAT),
      EndDate: moment(EndDate).format(DATE_FORMAT),
    };
    // const url = `${URLConstants.ShiftManagement}/List?PageNo=1&PageSize=100&Column="shift_name"&OrderBy="asc"`;
    const url = `${URLConstants.ShiftManagement}/ShiftSchedule/List?StoreId=${storeId}&StartDate=${dateFilter.StartDate}&EndDate=${dateFilter.EndDate}&userId=${userId}&gender=${gender}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ShiftSchedule[]>>) => {
        if (response.data.Error) {
          this.staffShiftScheduleState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.shiftScheduleList = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.staffShiftScheduleState.error = err;
      })
      .finally(
        action(() => {
          this.staffShiftScheduleState.inProgress = false;
        })
      );
  };

  get getShiftScheduleList() {
    return this.shiftScheduleList.length > 0
      ? this.shiftScheduleList.map((shiftSchedule) => {
          return {
            Id: shiftSchedule.Id,
            ShiftId: shiftSchedule.ShiftId,
            StaffId: shiftSchedule.UserId,
            Date: moment(shiftSchedule.ShiftDate).format(DateTimeFormatTZ),
            Type: shiftSchedule.ScheduleType,
            Name: shiftSchedule.ShiftRegistration.ShiftName,
            ShiftName: shiftSchedule.ShiftRegistration.ShiftName,
            ShiftShortName: shiftSchedule.ShiftRegistration.ShiftShortName,
            StartTime:
              shiftSchedule.ShiftId > 0
                ? shiftSchedule.ShiftRegistration.StartTime
                : shiftSchedule.FreeStartTime,
            EndTime:
              shiftSchedule.ShiftId > 0
                ? shiftSchedule.ShiftRegistration.EndTime
                : shiftSchedule.FreeEndTime,
            Colour: shiftSchedule.ShiftRegistration.Colour,
            BusinessTiming: shiftSchedule.BusinessVM,
            StoreId: shiftSchedule.StoreId,
          };
        })
      : [];
  }

  resetShiftScheduleList = () => {
    this.shiftScheduleList = [];
  };

  GetAppointmentByIdService = (id: number) => {
    this.appointmentByIdState.inProgress = true;
    let url = `${URLConstants.GetAppointmentById}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.appointmentByIdState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.appointment = data;
        }
      })
      .catch((err: string) => {
        this.appointmentByIdState.error = err;
      })
      .finally(
        action(() => {
          this.appointmentByIdState.inProgress = false;
        })
      );
  };

  get apponitmentDetail(): any {
    if (this.appointment) {
      return {
        id: this.appointment.Id,
        CustomerId: this.appointment.CustomerId,
        StoreId: this.appointment.StoreId,
        StaffPreference: this.appointment.StaffPreference,
        RequestedStaffId: this.appointment.RequestedStaffId,
        AssignedStaffId: this.appointment.AssignedStaffId,
        Date: this.appointment.Date,
        Time: this.appointment.Time,
        Start: combineDateTime(this.appointment.Date, this.appointment.Time),
        End: moment(
          combineDateTime(this.appointment.Date, this.appointment.Time).add(
            120,
            "minutes"
          )
        ),
        Store: this.appointment.store,
        StaffName: this.appointment.StaffName,
        AppointmentStatus: this.appointment.AppointmentStatus,
        PaymentType: this.appointment.PaymentType,
        ServiceRequestedVMss: this.appointment.ServiceRequestedVMss,
        ReservationMemo: this.appointment?.ReservationMemo,
        BookingType: this.appointment?.BookingType,
        TotalTime: this.appointment?.TotalTime,
        TotalAmount: this.appointment?.TotalAmount,
        TotalTaxes: this.appointment?.TotalTaxes,
        ConsumptionTax: this.appointment?.ConsumptionTax,
        NominationFee: this.appointment?.NominationFee,
        BusinessTypeId: this.appointment?.BusinessTypeId,
        CancellationType: this.appointment?.CancellationType,
        PostBreakTime: this.appointment?.PostBreakTime,
        Reception: this.appointment?.AppointmentStatus == 3 ? true : false,
      };
    }
    return {
      id: 0,
      CustomerId: 0,
      StoreId: 0,
      StaffPreference: false,
      RequestedStaffId: 0,
      AssignedStaffId: 0,
      Date: "",
      Time: "",
      Start: "",
      End: "",
      Store: "",
      StaffName: "",
      AppointmentStatus: "",
      PaymentType: "",
      ServiceRequestedVMss: [],
      ReservationMemo: "",
      BookingType: 0,
      CancellationType: 0,
      PostBreakTime: 0,
      Reception: false,
    };
  }

  resetAppointmentDetail = () => {
    this.appointment = undefined;
  };

  GetNoOfAvailabilityServiceDatesBlock = (
    id: number,
    storeId: number,
    startDate: string,
    endDate: string
  ) => {
    this.blockedAppointmentState.inProgress = true;
    let url = `${URLConstants.GetBlockedAppointment}?id=${id}&StoreId=${storeId}&StartDate=${startDate}&EndDate=${endDate}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.blockedAppointmentState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.blockedAppointment = data;
        }
      })
      .catch((err: string) => {
        this.blockedAppointmentState.error = err;
      })
      .finally(
        action(() => {
          this.blockedAppointmentState.inProgress = false;
        })
      );
  };

  get availableDatesBlock(): any[] {
    if (this.blockedAppointment?.length > 0) {
      return this.blockedAppointment?.map((dates) => {
        return {
          AppointmentDate: dates.AppointmentDate,
          StartTime: dates.StartTime,
          EndTime: dates.EndTime,
        };
      });
    }
    return [];
  }

  resetBlockedAppointment = () => {
    this.blockedAppointmentState = { ...this.initialStateValue };
    this.blockedAppointment = [];
  };

  GetTheDateTimeSlotsMappingService = (
    userId: any,
    storeId: number,
    startDate: string,
    endDate: string,
    gender: any,
    minuteInterval: number,
    treatmentMinutes: number,
    treatmentIds: number[]
  ) => {

    let dataObj = {
      StartDate: startDate,
      EndDate: endDate,
      MinuteInterval: minuteInterval,
      TotalTreatmentTime: treatmentMinutes,
      StaffId: userId == 0 ? null : Number(userId),
      Gender: gender !== "" ? Number(gender): null,
      StoreId: storeId,
      TreatmentIds: treatmentIds,
    };
    
    this.mapSlot = undefined;

    this.mapSlotState.inProgress = true;
    let url = `AppointmentManagement/MapBookingCalendar`;
    return baseService
      .postRequest(url, dataObj)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.mapSlotState.error = response.data.Message;
          toast.error(formatMessage("ReservationSettingsNotSet"));
        } else {
          this.mapSlot = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.mapSlotState.error = err;
      })
      .finally(
        action(() => {
          this.mapSlotState.inProgress = false;
        })
      );
  };

  get mapCalendarSlots(): any {
    if (this.mapSlot?.MapSlots?.length > 0) {
      return this.mapSlot?.MapSlots?.map((slots: any) => {
        return {
          Date: slots.Date,
          TimeSlots: slots?.TimeSlots,
        };
      });
    }
    return [];
  }

  GetCancelledReservationListService = (
    pageNo: number,
    pageSize: number,
    startDate: string,
    endDate: string,
    storeId?: number,
    businessTypeId?: number
  ) => {
    this.getCancelledReservationListState.inProgress = true;

    let url =
      URLConstants.GetCancelledReservationList +
      `?PageNo=${pageNo}` +
      `&PageSize=${pageSize}` +
      `&StartDate=${startDate}` +
      `&EndDate=${endDate}` +
      (storeId ? `&StoreId=${storeId}` : "") +
      (businessTypeId ? `&BusinessTypeId=${businessTypeId}` : "");

    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<ICancellationListVM>>) => {
          if (response.data.Error) {
            this.getCancelledReservationListState.error = response.data.Message;
          } else {
            let data = response.data.Data;
            this.cancelledReservationList = data;
          }
        }
      )
      .catch((err: string) => {
        this.getCancelledReservationListState.error = err;
      })
      .finally(
        action(() => {
          this.getCancelledReservationListState.inProgress = false;
        })
      );
  };

  setBookingStatus = (status: number) => {
    this.bookingStatus = status;
  };

  get getBookingStatus() {
    return this.bookingStatus;
  }

  get allCancelledReservations(): any[] {
    return (
      this.cancelledReservationList?.CancellationTypeVMs?.map((item) => {
        return {
          Id: item.Id,
          CustomerId: item.CustomerId,
          StoreId: item.StoreId,
          CustomerName: item.CustomerName || "N/A",
          CancelationType: item.CancelationType,
          BookingType: item.BookingType,
          Date: item.Date,
          Time: item.Time,
          CancellationTimeFormatted: item.CancellationTime
            ? moment(item.CancellationTime).format("YYYY-MM-DD HH:mm")
            : "N/A",
        };
      }) || []
    );
  }

  setSelectedService = (data:any) => {
    this.selectedService = data;
  }

  setIsSourceFeatured = (value:boolean) => {
    this.isSourceFeatured = value;
  }

  get getIsSourceFeatured() {
    return this.isSourceFeatured;
  }

  get getSelectedService() {
    if(this.selectedService){
      return {
        CategoryId: this.selectedService.CategoryId,
        TreatmentId: this.selectedService.TreatmentId,
        OptionIds: this.selectedService.OptionIds
      }
    }
    else{
      return undefined;
    }
  }
}
export default new BookingManagementStore();
